import React from "react";
import SocialSigninButtons from "@packages/shared-components/user-profile/signin-signup/social-signin-buttons";
import {
  getLeadFormGAContext,
  trackLeadFormContinueWithGoogle,
  trackLeadFormContinueWithApple,
} from "./ga-tracking";
import { storeGAContextForOAuth, SubmissionType } from "@packages/shared-components/user-profile/signin-signup/ga-tracking";

type SignInSectionProps = {
  heading?: string;
  description?: React.ReactNode;
  onSignInClick?: () => void;
};

const SignInSection = ({
  onSignInClick,
}: SignInSectionProps) => {
  const defaultDescription = (
    <>
      One account. All the support you need to make your
      university choice. Sign up to Whatuni, Complete University Guide and Postgraduate Search.{" "}
      <button
        type="button"
        className="text-primary-400 underline cursor-pointer bg-transparent border-none p-0 inline"
        onClick={onSignInClick}
      >
        Sign in
      </button>{" "}
      if you have an account
    </>
  );

  /** Handle social login click with lead form GA context + Clickstream (Java parity) */
  const handleLeadFormSocialLogin = (provider: "Google" | "Apple") => {
    const ctx = getLeadFormGAContext();
    if (provider === "Google") {
      trackLeadFormContinueWithGoogle(ctx);
    } else {
      trackLeadFormContinueWithApple(ctx);
    }
    // Store GA context for OAuth redirect return (lead form context uses form_type from lead form)
    const submissionType: SubmissionType = provider === "Google" ? "google" : "apple";
    storeGAContextForOAuth({ formType: ctx.formType, field: ctx.field }, submissionType);
  };

  return (
    <div className="border-t border-b border-grey-200 py-[32px] px-0 md:px-[16px] flex flex-col gap-[24px]">
      <div className="flex flex-col gap-[8px] text-center">
        <h2 className="text-heading6 font-farro font-bold">Sign in or create an account</h2>
        <p className="text-small">{defaultDescription}</p>
      </div>
      <SocialSigninButtons onBeforeSocialLogin={handleLeadFormSocialLogin} />
    </div>
  );
};

export default SignInSection;
